/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderSummaryCapability {
    CHECKOUT_APPLY_DISCOUNT_CODES = 'checkout:apply_discount_codes',
}
